module.exports = __webpack_public_path__ + "img/vvip-onboarding-gift.7eaf99b8.webp";